import { DMCObject } from "./DMCObject";
import Konva from "konva";

export class DMCRectangle extends DMCObject {
  constructor(name, konvaObject) {
    super(name, konvaObject);
  }

  copyOption(DMCObject, controllerProject) {
    const newOption = super.copyOption(DMCObject, controllerProject);
    return newOption;
  }

  createNewObject(DMCObject) {
    return new Konva.Rect(DMCObject.konvaObjectOption);
  }

  getType() {
    return "Rect";
  }

  loadEnd(obj) {
    const color = obj.konvaObjectOption.fill;
    this.setColor(color);

    return obj;
  }

  // Setters
  setColor(val) {
    this.konvaObject.setAttr("fill", val);
    return val;
  }
}
